type Environment = 'development' | 'staging' | 'production';

const getCurrentEnv = (): Environment => {
  const env = process.env.REACT_APP_ENV as Environment | undefined;
  if (env && ['development', 'staging', 'production'].includes(env)) return env;
  if (process.env.NODE_ENV === 'production') return 'production';
  return 'development';
};

const currentEnv = getCurrentEnv();

function requireEnv(key: string): string {
  const value = process.env[key];
  if (!value) {
    console.error(`[CONFIG] Variável de ambiente obrigatória não configurada: ${key}`);
  }
  return value || '';
}

export const config = {
  env: currentEnv,

  // Supabase
  supabaseUrl: requireEnv('REACT_APP_SUPABASE_URL'),
  supabaseAnonKey: requireEnv('REACT_APP_SUPABASE_ANON_KEY'),
  supabaseFunctionsUrl: requireEnv('REACT_APP_SUPABASE_FUNCTIONS_URL'),
  stripePublishableKey: process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY?.trim() || '',

  // App
  appUrl: process.env.REACT_APP_APP_URL || '',

  /** Domínio raiz (ex.: marimosca.com.br) — referência / docs. */
  domainRoot: process.env.REACT_APP_DOMAIN_ROOT || 'marimosca.com.br',

  /** Planilha de controle conversão e cancelamento (2026) — aba de inadimplentes. */
  supportControlSheetUrl: process.env.REACT_APP_SUPPORT_CONTROL_SHEET_URL || '',

  // API
  apiUrl: process.env.REACT_APP_API_URL || '',
  apiTimeout: Number(process.env.REACT_APP_API_TIMEOUT) || 30000,
  enableLogging: process.env.REACT_APP_ENABLE_LOGGING === 'true',
};

export default config;
